import React, { Component } from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import Loader from "../utils/Loader";
import $ from 'jquery';
import { Link } from 'react-router-dom';
import { withRouter } from '../utils/withRouter';
import { connect } from "react-redux";
import { BASE_URL, toastError } from '../utils/constants';
import { getCmsContent_action } from '../actions/cms_action/cmsAction';

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            scrollPosition: 0, cmsMode: '', headerNavs: [],
            UserID: localStorage.getItem("UserID"),
            RoleID: localStorage.getItem("RoleID"),
            cmsSubheaderData: [],
            govtLogoList: [],
            downloadUrl: '',
        };
        this.onLogout = this.onLogout.bind(this);
        this.navLogin = this.navLogin.bind(this);
    }

    componentDidMount() {
        const sortUrl = BASE_URL.split("/api");
        this.setState({ downloadUrl: sortUrl[0] });
        this.handleScroll = () => {
            this.setState({ scrollPosition: window.scrollY });
        };
        if (Array.isArray(this.props.headerNavs) && this.props.headerNavs.length > 0) {
            this.setState({ headerNavs: this.props.headerNavs })
        } else {
            console.log('else header')
            this.getCmsContent(1, 'home');
        }
        const path = this.props.location.pathname;
        const cmsPrefix = '/cms';
        if (path.includes(cmsPrefix)) {
            this.setState({ cmsMode: 1 })
        } else {
            this.setState({ cmsMode: 0 })
        }
        window.addEventListener('scroll', this.handleScroll);

        $(document).ready(function () {
            $(".offcanvas__close, .offcanvas__overlay").on("click", function () {
                $(".offcanvas__info").removeClass("info-open");
                $(".offcanvas__overlay").removeClass("overlay-open");
            });

            $(".navigate__close, .offcanvas__overlay").on("click", function () {
                $(".offcanvas__info").removeClass("info-open");
                $(".offcanvas__overlay").removeClass("overlay-open");
            });

            $(".sidebar__toggle").on("click", function () {
                $(".offcanvas__info").addClass("info-open");
                $(".offcanvas__overlay").addClass("overlay-open");
            });

            $(".body-overlay").on("click", function () {
                $(".offcanvas__area").removeClass("offcanvas-opened");
                $(".df-search-area").removeClass("opened");
                $(".body-overlay").removeClass("opened");
            });

            $('#mobile-menu-toggle').on('click', function () {
                $('#mobile-menu').toggleClass('open');
            });
        });
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }
    getCmsContent = async (MenuID, MenuUrl) => {
        try {
            this.setState({ isLoading: true });

            const data = await this.props.getCmsContent_action(MenuID ? MenuID : 1, MenuUrl ? MenuUrl : 'home');
            if (data.error !== 1) {
                this.setState({
                    isLoading: false,
                    cmsMenuData: data?.data[1] !== "" ? data?.data[1] : [],
                    headerNavs: data?.data[1] !== "" ? data?.data[1] : [],
                    cmsSubheaderData: data?.data[4] !== "" ? data?.data[4] : [],
                    cmsBannerData: data?.data[5][0] !== "" ? data?.data[5][0] : [],
                    govtLogoList: data?.data[6] !== "" ? data?.data[6] : [],
                });
            } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }


    onLogout() {
        localStorage.clear();
        this.props.navigate('/');
    }

    navLogin() {
        sessionStorage.setItem('isLoginClicked', true);
        this.props.navigate('/login');
    }
    handleMenuClick(MenuID, Url, Title) {
        if (Title == 'Visitor Registration') {
            return;
        } else {

            localStorage.setItem("MenuID", MenuID);
            localStorage.setItem("Url", Url);

            const trimmedUrl = Url.trim();
            const externalUrlPattern = /^(https?:\/\/|www\.|ftp:\/\/|mailto:)/i;

            if (externalUrlPattern.test(trimmedUrl)) {
                window.open(trimmedUrl, '_blank');
            } else {
                const normalizedUrl = trimmedUrl.startsWith('/') ? trimmedUrl : '/' + trimmedUrl;
                const basePath = this.props.location.pathname.includes('/cms') ? '/cms/manage' : '';
                const newPath = `${basePath}${normalizedUrl}&${MenuID}`

                this.props.navigate(newPath);
            }
        }
    }

    render() {
        const { isLoading, headerNavs, cmsMode, cmsSubheaderData, govtLogoList, downloadUrl } = this.state;

        return (
            <>
                {isLoading && <Loader />}
                <header>
                    {/* === Top Header === */}
                    <div className="tg-header__top">
                        <div className="container custom-container">
                            <div className="row align-items-center">
                                {cmsSubheaderData?.length > 0 && (
                                    <>
                                        <div className="col-lg-4">
                                            <div className="tg-header__top-menu">
                                                <ul className="list-wrap mb-0">
                                                    {cmsSubheaderData
                                                        .filter(item => item.isActive == 1 && item.isPublish == 1 && item.ViewType === "SM")
                                                        .map(item => {
                                                            let iconClass = '';
                                                            let href = item.Link;

                                                            switch (item.SocialType) {
                                                                case 'Email':
                                                                    iconClass = 'fas fa-envelope';
                                                                    href = `mailto:${item.Link}`;
                                                                    break;
                                                                case 'Phone':
                                                                    iconClass = 'fas fa-phone';
                                                                    href = `tel:${item.Link}`;
                                                                    break;
                                                                case 'Instagram':
                                                                    iconClass = 'fab fa-instagram';
                                                                    break;
                                                                case 'Facebook':
                                                                    iconClass = 'fab fa-facebook-f';
                                                                    break;
                                                                case 'LinkedIn':
                                                                    iconClass = 'fab fa-linkedin-in';
                                                                    break;
                                                                case 'Twitter':
                                                                    iconClass = 'fab fa-twitter';
                                                                    break;
                                                                case 'Youtube':
                                                                    iconClass = 'fab fa-youtube';
                                                                    break;
                                                                default:
                                                                    iconClass = '';
                                                            }

                                                            // Ensure other links have https:// if not mailto or tel
                                                            const isSpecialLink = href.startsWith('mailto:') || href.startsWith('tel:');
                                                            if (!isSpecialLink && !/^https?:\/\//i.test(href)) {
                                                                href = `https://${href}`;
                                                            }

                                                            return (
                                                                <li key={item.SubheaderID}>
                                                                    <a href={href} target="_blank" rel="noopener noreferrer">
                                                                        {iconClass && <i className={`${iconClass} me-2`} />}
                                                                        {item.SubheaderName}
                                                                    </a>
                                                                </li>
                                                            );
                                                        })}
                                                </ul>
                                            </div>
                                        </div>

                                        {/* ViewType: BTN (Buttons) */}
                                        <div className="col-lg-8">
                                            <div className="tg-header__top-social text-end">
                                                {cmsSubheaderData
                                                    .filter(item => item.isActive == 1 && item.isPublish == 1 && item.ViewType == "BTN")
                                                    .map(item => (
                                                        <a
                                                            key={item.SubheaderID}
                                                            className="btn-blinker border mt-1 p-1 px-3 rounded-4 fw-normal d-inline-block me-2"
                                                            href={item.Link}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ fontSize: "12px" }}
                                                        >
                                                            {item.SubheaderName}
                                                        </a>
                                                    ))}
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* === Sticky Header === */}
                    <div id="header-fixed-height" />

                    <div id="sticky-header" className="tg-header__area" style={{ padding: '10px', paddingTop: '30px' }}>
                        <div className="container custom-container">
                            <div className="row">
                                <div className="col-12">
                                    <div className="tgmenu__wrap">
                                        {govtLogoList?.length > 0 ? <>
                                            {/* GOVT LOGO (separate row above nav) */}
                                            <div className="govt_logo text-end mb-2 d-flex justify-content-end align-items-center">
                                                {govtLogoList.length > 0 ? 'Supported By' : ''}
                                                {govtLogoList?.length > 0 &&
                                                    govtLogoList
                                                        .filter((data) => data.isActive == 1 && data.isPublish == 1)
                                                        .map((logo, index) => {
                                                            const imgSrc = logo.GovtLogoFilepath
                                                                ? `${downloadUrl}/${logo.GovtLogoFilepath.replace(/\\/g, "/")}`
                                                                : "https://via.placeholder.com/150x80?text=Logo";

                                                            const imgElement = (
                                                                <img
                                                                    key={index}
                                                                    src={imgSrc}
                                                                    alt="Govt Logo"
                                                                    style={{ height: "40px", marginLeft: "10px" }}
                                                                />
                                                            );

                                                            return logo.Link ? (
                                                                <a key={index} target="_blank" href={logo.Link}>
                                                                    {imgElement}
                                                                </a>
                                                            ) : (
                                                                imgElement
                                                            );
                                                        })}
                                            </div>
                                        </> : <></>}
                                        <nav className="tgmenu__nav container-fluid">
                                            <div className="row align-items-center">
                                                {/* Left Column - Logo (10%) */}
                                                <div className="col-2 col-md-2 d-flex justify-content-start">
                                                    <div className="logo">
                                                        <Link to="/">
                                                            <img src="assets/img/logo_2.png" alt="Logo" />
                                                        </Link>
                                                    </div>
                                                </div>

                                                {/* Center Column - Menu (80%) */}
                                                <div className="col-8 col-md-9">
                                                    <div className="tgmenu__navbar-wrap tgmenu__main-menu d-flex justify-content-center">
                                                        <ul className="navigation d-flex align-items-center justify-content-center gap-1 flex-wrap ">

                                                            {/* Dynamic Menu Code */}
                                                            {(() => {
                                                                const internalPages = [];
                                                                const filteredNavs = headerNavs?.filter(item => item.isActive && item.isPublish);
                                                                const parents = filteredNavs?.filter(item => item.ParentID === null);
                                                                const childrenMap = {};

                                                                filteredNavs?.forEach(item => {
                                                                    if (item.ParentID !== null) {
                                                                        if (!childrenMap[item.ParentID]) childrenMap[item.ParentID] = [];
                                                                        childrenMap[item.ParentID].push(item);
                                                                    }
                                                                });

                                                                const menuItems = parents?.sort((a, b) => a.Sequence - b.Sequence)?.map((parent) => {
                                                                    const hasChildren = childrenMap[parent.MenuID]?.length > 0;
                                                                    const showMenu = parent.isMenuItem || (hasChildren && childrenMap[parent.MenuID].some(child => child.isMenuItem));

                                                                    if (!showMenu && cmsMode) internalPages.push(parent);

                                                                    if (hasChildren) {
                                                                        return (
                                                                            <li key={parent.MenuID} className="menu-item-has-children for-cms" >
                                                                                <a style={{ fontSize: '13px' }}>{parent.Title}</a>
                                                                                <ul className="sub-menu">
                                                                                    {childrenMap[parent.MenuID]?.sort((a, b) => a.Sequence - b.Sequence)?.map(child => {
                                                                                        if (!child.isMenuItem && cmsMode) {
                                                                                            internalPages.push(child);
                                                                                            return null;
                                                                                        }
                                                                                        return (
                                                                                            <li key={child.MenuID} className={`${(child.Title == 'Visitor Registration') ? 'visitor_header_footer_click' : ''}`}>
                                                                                                <a onClick={() => {
                                                                                                    this.handleMenuClick(child.MenuID, child.Url, child.Title)
                                                                                                }} style={{ fontSize: '13px' }}>
                                                                                                    {child.Title}
                                                                                                </a>
                                                                                            </li>
                                                                                        );
                                                                                    })}
                                                                                </ul>
                                                                            </li>
                                                                        );
                                                                    }

                                                                    return showMenu ? (
                                                                        <li key={parent.MenuID}>
                                                                            <a onClick={() => this.handleMenuClick(parent.MenuID, parent.Url)} style={{ fontSize: '13px' }}>
                                                                                {parent.Title}
                                                                            </a>
                                                                        </li>
                                                                    ) : null;
                                                                });

                                                                // Add Internal Pages
                                                                if (cmsMode && internalPages.length > 0) {
                                                                    menuItems.push(
                                                                        <li key="internal-pages" className="menu-item-has-children for-cms">
                                                                            <a style={{ fontSize: '13px' }}>Internal Pages</a>
                                                                            <ul className="sub-menu">
                                                                                {internalPages.map((item) => (
                                                                                    <li key={item.MenuID}>
                                                                                        <a onClick={() => this.handleMenuClick(item.MenuID, item.Url)} style={{ fontSize: '13px' }}>
                                                                                            {item.Title}
                                                                                        </a>
                                                                                    </li>
                                                                                ))}
                                                                            </ul>
                                                                        </li>
                                                                    );
                                                                }

                                                                return menuItems;
                                                            })()}

                                                            {/* CMS Menu (if verified) */}
                                                            {localStorage.getItem('isVerified') && (
                                                                <li className="menu-item-has-children for-cms">
                                                                    <a style={{ fontSize: '13px' }}>CMS</a>
                                                                    <ul className="sub-menu">
                                                                        <li><Link to="/cms/manage">Switch to Editor Mode</Link></li>
                                                                        <li><Link to="/cms/header">Menu Settings</Link></li>
                                                                        <li onClick={() => this.onLogout()}><Link>Logout</Link></li>
                                                                    </ul>
                                                                </li>
                                                            )}
                                                        </ul>
                                                    </div>
                                                </div>

                                                {/* Right Column - Login/Action (10%) */}
                                                <div className="col-2 col-md-1 d-flex justify-content-end">
                                                    <div className="tgmenu__action">
                                                        <ul className="list-wrap m-0">
                                                            <li>
                                                                <a href="https://india-itme.com/"
                                                                    target="_blank"
                                                                    className="btn border-btn my_login_btn login_btn_click"
                                                                    style={{ padding: '10px', marginTop: '10px' }}>
                                                                    Login
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="mobile-nav-toggler ms-3">
                                                        <i className="tg-flaticon-menu-1" />
                                                    </div>
                                                </div>
                                            </div>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>

            </>
        );
    }
}


export default withRouter(connect(null, { getCmsContent_action })(Header));